import { render } from "./ChannelWrapper.vue?vue&type=template&id=27b55c3c&ts=true"
import script from "./ChannelWrapper.vue?vue&type=script&lang=ts"
export * from "./ChannelWrapper.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/thelounge/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__